<template>
  <div id="apply" ref="homePage" v-wechat-title="$route.meta.title">
    <router-view ref="pages" />
  </div>
</template>

<script>
export default {
  name: 'Apply',
  data() {
    return {
      openid: null,
      winH: null,
      income: ''
    }
  },
  created() {
    const that = this
    setTimeout(function() {
      that.winH = document.documentElement.clientHeight || document.body.clientHeight
      that.$refs.homePage.style.minHeight = that.winH + 'px'
    }, 100)
  },
  methods: {}
}
</script>

<style lang="less" scoped>
  #apply {
    background-color:#efefef;
  }
</style>
